import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";

import PerDayLineChart from "./PerDayLineChart";
import MonthlyBarChart from "./MonthlyBarChart";
import PerDayLineInvoice from "./PerDayLineInvoice";
import InvoiceBarChartMonthly from "./InvoiceBarChartMonthly";
import PerDayLineChartVoucher from "./PerDayLineChartVoucher";
import VoucherChartMonthly from "./VoucherChartMonthly";

const InvoiceDashboardCharts = () => {
  return (
    <>
      {/* Charts */}
      <Box
        sx={{
          width: "100%",
          display: "grid",
          gap: 4,
          gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
        }}
      >
        <PerDayLineChart
          title="Daily Sales"
          color="#29b6f6"
          dataKey="dailySales"
        />
        <MonthlyBarChart title="Monthly Sales" dataKey="monthlySales" />
        <PerDayLineChartVoucher
          title="Daily cash"
          color="#29b6f6"
          dataKey="VoucherData"
        />
        <VoucherChartMonthly
          title="Monthly cash"
          color="#29b6f6"
          dataKey="VoucherData"
        />
        <PerDayLineInvoice
          title="Daily Invoice"
          color="#29b6f6"
          dataKey="invoiceData"
        />
        <InvoiceBarChartMonthly
          title="Monthly Invoice"
          color="#29b6f6"
          dataKey="invoiceData"
        />
      </Box>
    </>
  );
};

export default InvoiceDashboardCharts;
